import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { statusAdapter } from '../constants/status-adapter.constant';

export const approveOrderAdapter = (trxId, status, pharmacy) => {
	return {
		trx_id: trxId?.toString(),
		pharmacy: pharmacy,
		status: statusAdapter[Enviroment.LANGUAGE][status],
	};
};
